<template>
    <!-- subscribe-section -->
    <section class="subscribe-section">
        <div class="bg-color"></div>
        <div class="auto-container">
            <div class="inner-container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12 col-sm-12 text-column">
                        <div class="text-box mr_50">
                            <h2>Subscribe for latest update about kotina</h2>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 form-column">
                        <div class="form-inner ml_65">
                            <form method="post" action="contact.html">
                                <div class="form-group">
                                    <Form autocomplete="off" @submit="onSubmit" :validation-schema="schema" v-slot="{errors}" class="bg-body d-flex">
                                        <Field type="text" name="emailname" v-model="emailValuecomp.EmailValue"
                                               :class="{ 'form-control' : true ,'is-invalid': errors.emailname }"
                                               :placeholder="$t('StoreFront.EnterEmail')" />
                                        <div class="invalid-feedback">{{errors.emailname}}</div>
                                        <button type="submit" class="btn btn-dark"><i class="fas fa-paper-plane"></i> {{$t('StoreFront.Subscribe')}}</button>
                                    </Form>


                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- subscribe-section end -->
</template>
<script>
    import { Form, Field } from 'vee-validate';
    export default {
        components: {
            Form, Field
        },
        props: ['schema',"emailValuecomp"],
        emits: ["submitNewsLetter"],
        data() {
            return {
                showForm: true
            }
        },
        methods: {
            onSubmit() {              
                this.showForm = false;                
                this.$emit("submitNewsLetter", this.emailValuecomp.EmailValue);
            }            
        }
    }
</script>